module.exports = __webpack_public_path__ + "img/SKSM-banner.5e3f6151.jpg";